import withLohonoBlackTheme from "./with-lohono-black-theme";

export default withLohonoBlackTheme;